import * as coachMarkerConstants from 'constants/coachMarkers';
import {
	SET_GENERAL_DETAILS,
	SET_SELECTED_OFFER,
	SET_COACHMARKER_DETAILS,
	SET_LOADPAY_COACHMARKER_DETAILS,
	SET_ALL_OFFERS,
} from 'redux/actionTypes';

const initialState = {
	parentFaq: '',
	activeBottomTab: 'Home',
	coachMarkers: {
		enabled: false,
		steps: coachMarkerConstants.steps,
		fromProfile: false,
		stepsUpdated: true,
	},
	offers: {
		active: null,
		all: null,
	},
};

const GeneralDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_GENERAL_DETAILS:
			return {
				...state,
				...action.data,
			};
		case SET_COACHMARKER_DETAILS:
			return {
				...state,
				coachMarkers: {
					...state.coachMarkers,
					...action.payload,
				},
			};
		case SET_LOADPAY_COACHMARKER_DETAILS:
			return {
				...state,
				loadPayCoachMarkers: {
					...state.loadPayCoachMarkers,
					...action.payload,
				},
			};
		case SET_SELECTED_OFFER:
			return {
				...state,
				offers: {
					...state.offers,
					active: action.payload,
				},
			};
		case SET_ALL_OFFERS:
			return {
				...state,
				offers: {
					...state.offers,
					all: action.payload,
				},
			};

		default:
			return state;
	}
};

export default GeneralDetailsReducer;
